import { ReactElement } from 'react';
import { Text } from '~/components/typography';
import { useDialog } from '~/hooks';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

interface Props {
  target: ReactElement;
  copy?: {
    sectionOne: {
      title: string;
      list: string[];
    };
    sectionTwo: {
      title: string;
      text: string[];
    };
  };
}

export const CommunitySolarExplainerDialog = ({ target, copy }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);

  return (
    <>
      {TargetComponent}
      <Dialog isOpen={isOpen} onDismiss={close} aria-label="Community Solar Explainer">
        <Dialog.Header title="Why join a community solar farm?" onClose={close} />
        <DialogSection
          title={
            copy?.sectionOne?.title || 'What are the benefits of joining a community solar farm?'
          }
        >
          <Text>
            {copy?.sectionOne?.list.map(item => <li key={item}>{item}</li>) ||
              [
                "You don't need to switch utilities to join",
                'Guaranteed savings on the solar credits applied to your power bill',
                'No rooftop installation',
                'Available for houses or apartments',
                'No extra cost or long-term commitments',
                'Clean energy added to the power supply',
              ].map(item => <li key={item}>{item}</li>)}
          </Text>
        </DialogSection>
        <DialogSection
          title={
            copy?.sectionTwo?.title || 'The savings seem too good to be true! How does it work?'
          }
        >
          {copy?.sectionTwo?.text || [
            'States like yours create community solar programs to encourage the development of more clean energy. As part of those programs, residents are guaranteed to save money on the solar credits applied to their power bills when they subscribe to community solar farms.',
            'As a subscriber, part of your regular power bill gets repurposed to keep the community solar farm running (we handle this part for you). When the farm generates electricity, you get credits back on your bill. Think of it as a perk for supporting clean energy.',
          ]}
        </DialogSection>
        <Dialog.FooterStacked primaryText="Close" onSubmit={close} />
      </Dialog>
    </>
  );
};
